var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.625,
    height: 30.625,
    viewBox: "0 0 30.625 30.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fec753;}.b{fill:#35528c;}.c{fill:#1f3a60;}.d{fill:#99d3ff;}.e{fill:#5bb3ce;}.f{fill:#dcf3ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.703 -11)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15.312,
    cy: 15.312,
    r: 15.312,
    transform: "translate(0.703 11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.021 2.943)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.994,105.467c-5.292,0-9.724,4.773-10.867,6.117a.538.538,0,0,0,0,.7C1.271,113.624,5.7,118.4,10.994,118.4s9.724-4.773,10.866-6.117a.538.538,0,0,0,0-.7C20.718,110.24,16.286,105.467,10.994,105.467Z",
    transform: "translate(0 -88.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.152,111.932c0-1.044,4.116-6.465,9.192-6.465-5.249,0-9.651,4.7-10.838,6.083a.588.588,0,0,0,0,.764C1.693,113.7,6.1,118.4,11.344,118.4c-5.077,0-9.192-5.421-9.192-6.465Z",
    transform: "translate(-0.351 -88.563)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5.669,
    cy: 5.669,
    r: 5.669,
    transform: "translate(5.325 17.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M126.233,129.669a5.671,5.671,0,0,1,4.552-5.559,5.669,5.669,0,1,0,0,11.118A5.671,5.671,0,0,1,126.233,129.669Z",
    transform: "translate(-118.675 -106.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.817,
    cy: 2.817,
    r: 2.817,
    transform: "translate(8.117 20.552)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 1.2,
    cy: 1.2,
    r: 1.2,
    transform: "translate(12.029 20.865)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5b45c682ccb94828d7afe355337fe214.svg";
export { ForwardRef as ReactComponent };